import { usePathname } from 'next/navigation';

const FIXED_HEADER_PATH_SEGMENTS = [
  '/games',
  '/oktoberfest',
  '/headline-promo',
];

export const useFixedHeader = (locale: string) => {
  const pathname = usePathname();
  const isLobby = pathname === '/' || pathname === `/${locale}`;

  return (
    isLobby ||
    FIXED_HEADER_PATH_SEGMENTS.some((segment) => pathname.includes(segment))
  );
};
